
export class MapPlace {
    public Label: string = '';                  // Concatenación de todos los campos
    public Street: string = '';                 // Calle
    public StreetNumber: string = '';           // Número de portal
    public Locality: string = '';               // Municipio si "District" no es nulo, sino, es la localidad
    public AdministrativeArea2: string = '';    // Provincia
    public AdministrativeArea1: string = '';    // Comunidad autónoma
    public PostalCode: string = '';             // Código postal
    public Country: string = '';                // Pais
    public District: string = '';               // Localidad (nulo cuando no hay municipio)
}
